import { render, staticRenderFns } from "./DefaultMain.vue?vue&type=template&id=0084fd4a&scoped=true"
import script from "./DefaultMain.vue?vue&type=script&lang=js"
export * from "./DefaultMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084fd4a",
  null
  
)

export default component.exports